import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "@/lib/api";
import { RefreshCw, Quote } from "lucide-react";

export default function AffirmationCard() {
  const [affirmation, setAffirmation] = useState(null);
  const [index, setIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadDaily = async () => {
    try {
      const res = await api.get("/affirmation/daily");
      setAffirmation(res.data.text);
      setIndex(res.data.index);
    } catch (e) {
      setAffirmation("The work doesn't leave you. It just goes quiet.");
    }
  };

  const drawAnother = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await api.get("/affirmation/new", {
        params: index != null ? { exclude: index } : {},
      });
      setAffirmation(res.data.text);
      setIndex(res.data.index);
    } catch (e) {
      /* keep current */
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDaily();
  }, []);

  return (
    <div
      data-testid="affirmation-card"
      className="relative h-full border border-[#F4F1EC]/12 bg-[#F4F1EC]/[0.03] backdrop-blur-sm p-8 md:p-10 flex flex-col overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-16 -right-16 w-56 h-56 blur-3xl opacity-40"
        style={{
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(230,191,255,0.6) 0%, rgba(7,6,8,0) 70%)",
        }}
      />
      <div className="flex items-center justify-between">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/55 font-body">
          Today&apos;s affirmation
        </span>
        <Quote size={18} strokeWidth={1.4} className="text-[#E6BFFF]" />
      </div>

      <div className="flex-1 flex items-center py-10 min-h-[180px]">
        <AnimatePresence mode="wait">
          <motion.p
            key={affirmation}
            data-testid="affirmation-text"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -14 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-[26px] md:text-[30px] leading-[1.25] text-[#F4F1EC] italic font-light"
          >
            {affirmation || "…"}
          </motion.p>
        </AnimatePresence>
      </div>

      <button
        data-testid="affirmation-draw-button"
        onClick={drawAnother}
        disabled={loading}
        className="self-start inline-flex items-center gap-2 font-body text-[11px] uppercase tracking-[0.24em] text-[#F4F1EC]/70 hover:text-[#FFB7C6] transition-colors disabled:opacity-50"
      >
        <RefreshCw
          size={14}
          strokeWidth={1.6}
          className={loading ? "animate-spin" : ""}
        />
        Draw another
      </button>
    </div>
  );
}
